import { render, staticRenderFns } from "./EditTextConfirmModal.vue?vue&type=template&id=6c03059c&lang=pug"
import script from "./EditTextConfirmModal.vue?vue&type=script&lang=ts"
export * from "./EditTextConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports